import React from 'react';
import { Field, Image as CardImage, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';
import { sanitize } from 'isomorphic-dompurify';

import { icon_arrow_right } from '@gn-audio/icons';
import { Button, ImageValue } from '@gn-audio/jss-components';
import { JabraIcon } from '@gn-audio/jss-components';

export type SliderCardProps = {
  id?: string;
  Header: Field<string>;
  Description: Field<string>;
  Image: Field<ImageValue>;
  Link: LinkField;
};

const SliderCard = ({
  Header,
  Description,
  Image,
  Link,
  id,
}: SliderCardProps): React.ReactElement => {
  return (
    <div className="flex h-[29rem] w-[21rem] flex-col rounded-3xl bg-white shadow-md md:w-[24rem]">
      <CardImage
        className="h-[14rem] w-full rounded-t-3xl object-cover"
        field={{ src: Image?.value.src }}
        alt={Image?.value.alt}
      />
      <div className="flex h-full flex-col p-4">
        <div>
          <h3 className="heading-5" id={`headerCard-${id}`}>
            {Header?.value}
          </h3>
          <p
            className="paragraph line-clamp-2 md:line-clamp-4"
            dangerouslySetInnerHTML={{ __html: sanitize(Description?.value) }}
          ></p>
        </div>
        <div className="mt-auto flex justify-end">
          <Button
            variant="tertiary"
            asLink={true}
            href={Link?.value.href}
            size={'m'}
            icon={<JabraIcon Icon={icon_arrow_right} />}
            aria-labelledby={`headerCard-${id}`}
          />
        </div>
      </div>
    </div>
  );
};

export default SliderCard;
